import React from 'react'
import '../../styles/components/_footer.scss';
import Icon from '../../components/Icons/Icon';
import { FaYoutube, FaTwitter, FaFacebook, FaInstagram } from 'react-icons/fa';
function FooterSecond() {
  return (
    <footer className="footer-second">
    <div className="footer-container">
    <div className="row">
      <div className="col-md-2">
             <div className="footer-logo">
              <a href="#"><img src="/assets/images/logo.png" alt="Belediye Logo" /></a>
             </div>
      </div>
      <div className="col-md-3">
      <div className="footer-widget">
                <div className="footer-widget-second">
                  <ul>
                    <li><a href="tel:905305421939"><Icon icon="Phone" size="28" /> Telefon: +90 530 542 19 39</a></li>
                    <li><a href="#"><Icon icon="Printer" size="28" /> Fax: 444 1 939</a></li>
                    <li><a href="mailto:belediye@iskenderun.bel.tr"><Icon icon="EnvelopeSimple" size="28" /> E-Posta: belediye@iskenderun.bel.tr</a></li>
                  </ul>
                </div>
              </div>
      </div>
      <div className="col-md-3">
      <div className="footer-widget">
                <div className="footer-widget-second">
                  <ul>
                    <li><a href="#"><Icon icon="MapPin" size="28" /> Adres: Yenişehir, Mareşal Fevzi Çakmak Cd. 
                    No:48, 31200 İskenderun/Hatay</a></li>
                    <li><a href="tel:4441939"><Icon icon="Broadcast" size="28" /> Santral: 444 1 939</a></li>
                  </ul>
                </div>
              </div>
      </div>
      <div className="col-md-2">
        <div className="footer-widget">
          <div className="footer-widget-butt">
            <a href=""><Icon icon="whatsapp" size="40" /> Whatsapp Destek Hattı</a>
            <a href="">Bize Ulaşın</a>
          </div>
        </div>
      </div>
      <div className="col-md-2">

      </div>
    </div>
    </div>
   
  
  </footer>
  )
}

export default FooterSecond
